import { Container, ShowFor, HideFor, Size, 
    // AddThis 
} from "@brightagency/headstart-common";
import React from "react";
import { useGlobalAcf } from "../../../services/app-state";
import { useSuburbName ,useSuburbInformationNullable } from "../../../utils";
import { Acknowledgements } from "./Acknowledgements";
import { Links } from "./Links";
import { RegionInfo } from "./RegionInfo";
import { ScrollToTop } from "./ScrollToTop";
import { Outer, Inner, Separator, AckRegionWrapper, Copyright } from "./styled";

export const Footer = () => {
    const [{ footer }] = useGlobalAcf();
    const copyrightText = footer.copyright.replace("{{year}}", String(new Date().getFullYear()));
    const suburbName = useSuburbName();
    
    const suburbdetailblurb = useSuburbInformationNullable()?.regionblurb;
    const suburbdetaillogo = useSuburbInformationNullable()?.region_logo;

    const renderDesktop = () => {
        
        return (

            <><>
                <Links classname='' links={footer.links} />
                {/* <AddThis /> */}
                <Separator />
            </>
            
            <>
                { 
                    suburbdetailblurb ? (
                        <><AckRegionWrapper className='regionselected'>
                                <Acknowledgements classname='acknowledge-desktop' content={footer.acknowledgements} additionalcontent={footer.additional_acknowledgements}/>
                                {suburbName ? (
                                    <RegionInfo  classname="" copy={suburbdetailblurb} logo={suburbdetaillogo} />
                                ) : ('')}
                            </AckRegionWrapper>
                            {/* <AckRegionWrapper>
                                    <Acknowledgements content={footer.additional_acknowledgements} />
                                </AckRegionWrapper> */}
                        </>
                    ) : (
                        <><AckRegionWrapper className='regionnotselected'>
                                <Acknowledgements classname='acknowledge-left' content={footer.acknowledgements} additionalcontent=''/>
                                <Acknowledgements classname='acknowledge-right' content={footer.additional_acknowledgements} additionalcontent=''/>
                                {/* <Acknowledgements content={footer.additional_acknowledgements} /> */}
                            </AckRegionWrapper></>

                    )
                }

            </>
                <Separator />
            </>
            
        );
    };

    const renderMobile = () => {
        return (
            <>
                <ScrollToTop />
                {suburbName ? (
                        suburbdetailblurb ? (
                            <>
                            <RegionInfo classname="mobileregioninfo" copy={suburbdetailblurb} logo={suburbdetaillogo} />
                            <Separator />
                            </>
                        ) : ('')
                    ) : ('')
                }

                {suburbName ? (
                        <>
                            <Links classname='mobilefooterlink' links={footer.links} />
                            </>
                    ) : (
                        <>
                        <Links classname='' links={footer.links} />
                        </>
                    )
                }
                
                
                {/* <AddThis /> */}
                <Separator />
                <Acknowledgements classname='' content={footer.acknowledgements} additionalcontent=''/>
                <Acknowledgements classname='addional_acknowledgement' content={footer.additional_acknowledgements} additionalcontent=''/>
                {/* <Acknowledgements content={footer.additional_acknowledgements} /> */}
                <Separator />
            </>
        );
    };

    return (
        <Outer>
            <Container>
                <Inner>
                    <ScrollToTop />
                    <ShowFor size={Size.large}>{renderDesktop()}</ShowFor>
                    <HideFor size={Size.large}>{renderMobile()}</HideFor>
                    <Copyright>{copyrightText}</Copyright>
                </Inner>
            </Container>
        </Outer>
    );
};
